import React, { useEffect, useState } from 'react';
import WalletDashboardCard from '../../components/WalletDashboardCard';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
import { RangoWidget, StripeOnRamp } from './components';
import { useTour } from '../../hooks/useTour';


const OnRamp = () => {
  const { user } = useAuth();
  const { theme } = useTheme();
  const { startTour } = useTour();
  const [activeTab, setActiveTab] = useState('stripe');

  useEffect(() => {
    document.title = "Buy - KAXAA Wallet";
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      startTour(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, [startTour]);


  return (
    <>
      <div className="">
        <main className="">
          <div className="wallet-dashboard">
            <div className="grid grid-cols-[600px_1fr] gap-[30px] items-start">
              <div className="sticky top-10">
                <WalletDashboardCard />
                <div className='card account-card'>
                  <div className='flex gap-2'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" style={{ minWidth: '18px' }} viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4m0-4h.01" /></g></svg>
                    Please purchase KAX tokens using your financial card of choice.
                  </div>
                </div>
              </div>
              <div id="tour-buy-container" style={{ maxWidth: '650px' }}>
                <h1 className="text-2xl font-semibold mb-4">Buy</h1>
                
                {/* Tabs Selector */}
                <div className="d-flex align-items-stretch gap-2 mb-4 bg-light dark:bg-gray-800/10 p-1 rounded-3" style={{ minHeight: '44px' }}>
                  <button
                    onClick={() => setActiveTab('stripe')}
                    className={`btn flex-fill py-2 px-3 rounded-2 d-flex align-items-center justify-content-center ${activeTab === 'stripe' ? 'btn-primary shadow-sm text-white' : 'btn-light border-0 text-muted bg-transparent'}`}
                    style={{ fontWeight: '500', height: '100%', minHeight: '40px' }}
                  >
                    Stripe
                  </button>
                  <button
                    onClick={() => setActiveTab('rango')}
                    className={`btn flex-fill py-2 px-3 rounded-2 d-flex align-items-center justify-content-center ${activeTab === 'rango' ? 'btn-primary shadow-sm text-white' : 'btn-light border-0 text-muted bg-transparent'}`}
                    style={{ fontWeight: '500', height: '100%', minHeight: '40px' }}
                  >
                    Crypto Swap (Rango)
                  </button>
                </div>

                {activeTab === 'stripe' && (
                  <StripeOnRamp
                    walletAddress={user?.wallet?.publicWalletAddress}
                    email={user?.email}
                    theme={theme}
                  />
                )}

                {activeTab === 'rango' && (
                  <RangoWidget />
                )}
              </div>
            </div>
          </div>
        </main >
      </div >
    </>
  );
};

export default OnRamp;
